import { render, staticRenderFns } from "./listAlertItem.vue?vue&type=template&id=35917dc4&"
import script from "./listAlertItem.vue?vue&type=script&lang=js&"
export * from "./listAlertItem.vue?vue&type=script&lang=js&"
import style0 from "./listAlertItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports